import { common } from '@mtfe/sweet-utils';
const { genGuid } = common;

function _isNotUndefined(obj) {
    return typeof (obj) !== 'undefined';
}

window.__sweet = _isNotUndefined(window.__sweet) ? window.__sweet : {};
window.__sweet._root_pv_id = _isNotUndefined(window.__sweet._root_pv_id) ? window.__sweet._root_pv_id : genGuid();
window.__sweet._page_pv_id = _isNotUndefined(window.__sweet._page_pv_id) ? window.__sweet._page_pv_id : genGuid();
window.__sweet._page_session_id = _isNotUndefined(window.__sweet._page_session_id) ? window.__sweet._page_session_id : genGuid();
window.__sweet._page_session_id_last_time = _isNotUndefined(window.__sweet._page_session_id_last_time) ? window.__sweet._page_session_id_last_time : Date.now();

const getRootvId = () => {
    return window.__sweet._root_pv_id;
}

const getPagePvId = () => {
    return window.__sweet._page_pv_id;
}

const updatePagePvId = () => {
    window.__sweet._page_pv_id = genGuid();
}

const getPageSessionId = () => {
    if (Date.now() - window.__sweet._page_session_id_last_time > 1000 * 60 * 30) {// 30分钟过期
        window.__sweet._page_session_id = genGuid();
        window.__sweet._page_session_id_last_time = Date.now();
    }
    return window.__sweet._page_session_id;
}

const guidFactory = {
    getRootvId,
    getPagePvId,
    updatePagePvId,
    getPageSessionId
};

export default guidFactory;